import { render, staticRenderFns } from "./Editor.vue?vue&type=template&id=f00b02dc&scoped=true&"
import script from "./Editor.vue?vue&type=script&lang=ts&"
export * from "./Editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00b02dc",
  null
  
)

export default component.exports